const TYPE = 'USER_UPDATE';

const action = (payload) => (dispatch) => dispatch({ type: TYPE, payload });

export default { action, TYPE };
